import { TextSelection } from "prosemirror-state";
import React from "react";
import { EditorCursorPopup } from "../../popup/components/EditorCursorPopup/EditorCursorPopup";
import { disableUrlDialog, getUrlDialogPluginState } from "../plugins";
import { EditorUrlDialog } from "./EditorUrlDialog";
export const EditorUrlDialogPluginView = ({ view }) => {
    var _a;
    const { enable, target } = getUrlDialogPluginState(view.state);
    if (!enable || !target) {
        return null;
    }
    const { mark, from, to } = target;
    const attrs = ((_a = mark === null || mark === void 0 ? void 0 : mark.attrs) !== null && _a !== void 0 ? _a : { href: "" });
    if (attrs.href.startsWith("#")) {
        // avoid anchor links to display the URL dialog
        // anchor links are only used internally by ToC node
        return null;
    }
    const handleHrefChange = (href) => {
        const schema = view.state.schema;
        const tr = view.state.tr;
        tr.removeMark(from, to, schema.marks.link);
        if (href) {
            tr.addMark(from, to, schema.marks.link.create({ href }));
        }
        tr.setSelection(TextSelection.near(tr.doc.resolve(to)));
        disableUrlDialog(tr);
        view.dispatch(tr);
        view.focus();
    };
    return (React.createElement(EditorCursorPopup, { view: view, from: from, to: to, offsetTop: 8 },
        React.createElement(EditorUrlDialog, { href: attrs.href, onHrefChange: handleHrefChange })));
};
